import TWEEN from '@tweenjs/tween.js'
import bowser from 'bowser'
import { setOrientationChecked, setInFocus } from '../redux/actions'
import { updateTimeouts, addPendingTimeouts } from '../Utils/Timeout'
import { updateLoops } from '../Utils/Loop'
import setupListeners from './listeners'

let lastTimestamp = 0
let currentTime = 0

TWEEN.now = () => currentTime

let resetLoop = false
let store

export default async function initialize(_store) {
  store = _store

  currentTime = window.performance.now()

  setupListeners(store)
  document.addEventListener('visibilitychange', () => {
    store.dispatch(setInFocus(!document.hidden))

    resetLoop = true

    if (!document.hidden && bowser.mobile) {
      if (!this.enableSwipeCheck())  {
        store.dispatch(setOrientationChecked(false))
      }
    }
  })

  requestAnimationFrame(Loop)
}

/**
   * The main game loop, that updates the Tween ticker, FPS meter (in developer mode) and updates the current timestamp.
   */
const Loop = () => {
  const { base } = store.getState()
  const timestamp = window.performance.now()
  const delta = timestamp - lastTimestamp

  const adjustedDelta = delta * base.gamespeed

  addPendingTimeouts(adjustedDelta, base.gamespeed, timestamp)

  if (resetLoop) {
    resetLoop = false
  } else if (!base.paused) {
    updateTimeouts(adjustedDelta)

    updateLoops(adjustedDelta)

    currentTime += adjustedDelta
    
    TWEEN.update()
  }

  lastTimestamp = timestamp

  requestAnimationFrame(Loop)
}
